import React, { useState } from "react";
import Particles from "../Particels";

const ForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/request-password-reset`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      const result = await response.json();
      setMessage(
        result.message || "Prüfen Sie Ihre E-Mail für weitere Anweisungen."
      );
    } catch (error) {
      setMessage(
        "Etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-screen w-screen flex items-center">
      <Particles />
      <div className="max-w-md mx-auto mt-10 p-6 border rounded-lg shadow-lg">
        <h2 className="text-xl font-bold mb-4">Passwort vergessen</h2>
        <form onSubmit={handleSubmit}>
          <label className="block text-sm font-medium mb-2">
            E-Mail-Adresse
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-2 border rounded"
            required
          />
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-orange-500 text-white py-2 rounded mt-4 hover:bg-orange-600"
          >
            {loading ? "Senden..." : "Link senden"}
          </button>
        </form>
        {message && <p className="mt-4 text-sm text-gray-700">{message}</p>}
      </div>
    </div>
  );
};

export default ForgetPassword;
